/**
 * @generated SignedSource<<afc1e4e0f364c932d9345db097b2d981>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PianofunclubEnrolmentModelStatusChoices = "ARCHIVED" | "ENROLED" | "OFFERED" | "WAITING_LIST" | "%future added value";
export type PianofunclubLessonStageModelLessonTypeChoices = "GROUP" | "INDIVIDUAL" | "PAIRED" | "%future added value";
export type LoadEnrolmentQuery$variables = {
  enrolmentId: string;
};
export type LoadEnrolmentQuery$data = {
  readonly enrolment: {
    readonly adminNotes: string | null | undefined;
    readonly archivedTimestamp: string | null | undefined;
    readonly createdTimestamp: string | null | undefined;
    readonly enroledParent: {
      readonly id: string;
    } | null | undefined;
    readonly enroledPupil: {
      readonly id: string;
    } | null | undefined;
    readonly enroledTimestamp: string | null | undefined;
    readonly hasInvalidParentPhoneNumber: boolean;
    readonly id: string;
    readonly instrument: string | null | undefined;
    readonly lastOfferedTimestamp: string | null | undefined;
    readonly lessonStage: string | null | undefined;
    readonly lessonType: string | null | undefined;
    readonly offers: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly archived: boolean;
          readonly enrolment: {
            readonly id: string;
            readonly pupilFirstName: string | null | undefined;
            readonly pupilLastName: string | null | undefined;
          };
          readonly id: string;
          readonly lessonBlock: {
            readonly id: string;
            readonly instrument: {
              readonly id: string;
              readonly name: string | null | undefined;
            } | null | undefined;
            readonly lessonDay: number | null | undefined;
            readonly lessonStage: {
              readonly id: string;
              readonly lessonDuration: number | null | undefined;
              readonly lessonType: PianofunclubLessonStageModelLessonTypeChoices;
              readonly stage: number | null | undefined;
            } | null | undefined;
            readonly lessonTime: string | null | undefined;
            readonly teacher: {
              readonly id: string;
              readonly user: {
                readonly firstName: string;
                readonly id: string;
                readonly lastName: string;
              };
            } | null | undefined;
          } | null | undefined;
          readonly offerAccepted: boolean;
          readonly offerTimestamp: string | null | undefined;
        } | null | undefined;
      } | null | undefined>;
    };
    readonly parentEmail: string | null | undefined;
    readonly parentName: string | null | undefined;
    readonly parentPhoneNumber: string | null | undefined;
    readonly positionInWaitingList: number | null | undefined;
    readonly potentialDuplicatePupils: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly primaryParent: {
            readonly accountNumber: string | null | undefined;
            readonly id: string;
          } | null | undefined;
          readonly user: {
            readonly firstName: string;
            readonly id: string;
            readonly lastName: string;
          };
        } | null | undefined;
      } | null | undefined>;
    };
    readonly potentialDuplicates: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly pupilFirstName: string | null | undefined;
          readonly pupilLastName: string | null | undefined;
        } | null | undefined;
      } | null | undefined>;
    };
    readonly pupilFirstName: string | null | undefined;
    readonly pupilLastName: string | null | undefined;
    readonly pupilNotes: string | null | undefined;
    readonly school: {
      readonly archived: boolean;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly schoolBorough: string | null | undefined;
    readonly schoolClass: string | null | undefined;
    readonly schoolName: string | null | undefined;
    readonly schoolPostcode: string | null | undefined;
    readonly schoolYear: number | null | undefined;
    readonly status: PianofunclubEnrolmentModelStatusChoices;
    readonly teacherEmail: string | null | undefined;
  } | null | undefined;
};
export type LoadEnrolmentQuery = {
  response: LoadEnrolmentQuery$data;
  variables: LoadEnrolmentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "enrolmentId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pupilFirstName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pupilLastName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archived",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lessonType",
  "storageKey": null
},
v7 = [
  (v1/*: any*/)
],
v8 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "DjangoUserNode",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "enrolmentId"
      }
    ],
    "concreteType": "EnrolmentNode",
    "kind": "LinkedField",
    "name": "enrolment",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "SchoolNode",
        "kind": "LinkedField",
        "name": "school",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schoolName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schoolBorough",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schoolPostcode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schoolYear",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schoolClass",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lessonStage",
        "storageKey": null
      },
      (v6/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "instrument",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teacherEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "parentName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "parentEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "parentPhoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasInvalidParentPhoneNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pupilNotes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "adminNotes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "positionInWaitingList",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdTimestamp",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enroledTimestamp",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "archivedTimestamp",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastOfferedTimestamp",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileNode",
        "kind": "LinkedField",
        "name": "enroledPupil",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileNode",
        "kind": "LinkedField",
        "name": "enroledParent",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EnrolmentNodeConnection",
        "kind": "LinkedField",
        "name": "potentialDuplicates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EnrolmentNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EnrolmentNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileNodeConnection",
        "kind": "LinkedField",
        "name": "potentialDuplicatePupils",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileNode",
                    "kind": "LinkedField",
                    "name": "primaryParent",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accountNumber",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EnrolmentOfferNodeConnection",
        "kind": "LinkedField",
        "name": "offers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EnrolmentOfferNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EnrolmentOfferNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "offerTimestamp",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "offerAccepted",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EnrolmentNode",
                    "kind": "LinkedField",
                    "name": "enrolment",
                    "plural": false,
                    "selections": (v8/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LessonBlockNode",
                    "kind": "LinkedField",
                    "name": "lessonBlock",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lessonDay",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lessonTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LessonStageNode",
                        "kind": "LinkedField",
                        "name": "lessonStage",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "stage",
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lessonDuration",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InstrumentNode",
                        "kind": "LinkedField",
                        "name": "instrument",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileNode",
                        "kind": "LinkedField",
                        "name": "teacher",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LoadEnrolmentQuery",
    "selections": (v10/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LoadEnrolmentQuery",
    "selections": (v10/*: any*/)
  },
  "params": {
    "cacheID": "b54cdb6b986440715790bfb505d700ff",
    "id": null,
    "metadata": {},
    "name": "LoadEnrolmentQuery",
    "operationKind": "query",
    "text": "query LoadEnrolmentQuery(\n  $enrolmentId: ID!\n) {\n  enrolment(id: $enrolmentId) {\n    id\n    pupilFirstName\n    pupilLastName\n    school {\n      id\n      name\n      archived\n    }\n    schoolName\n    schoolBorough\n    schoolPostcode\n    schoolYear\n    schoolClass\n    lessonStage\n    lessonType\n    instrument\n    teacherEmail\n    parentName\n    parentEmail\n    parentPhoneNumber\n    hasInvalidParentPhoneNumber\n    pupilNotes\n    adminNotes\n    positionInWaitingList\n    status\n    createdTimestamp\n    enroledTimestamp\n    archivedTimestamp\n    lastOfferedTimestamp\n    enroledPupil {\n      id\n    }\n    enroledParent {\n      id\n    }\n    potentialDuplicates {\n      edges {\n        node {\n          id\n          pupilFirstName\n          pupilLastName\n        }\n      }\n    }\n    potentialDuplicatePupils {\n      edges {\n        node {\n          id\n          primaryParent {\n            id\n            accountNumber\n          }\n          user {\n            id\n            firstName\n            lastName\n          }\n        }\n      }\n    }\n    offers {\n      edges {\n        node {\n          id\n          offerTimestamp\n          offerAccepted\n          archived\n          enrolment {\n            id\n            pupilFirstName\n            pupilLastName\n          }\n          lessonBlock {\n            id\n            lessonDay\n            lessonTime\n            lessonStage {\n              id\n              stage\n              lessonType\n              lessonDuration\n            }\n            instrument {\n              id\n              name\n            }\n            teacher {\n              id\n              user {\n                id\n                firstName\n                lastName\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bf0ebbcf30e8fc9ba65e91c4ce5d985d";

export default node;
